var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgQrNotAvaiable(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "fi_2797387"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M11.2793 21.9139C11.2791 21.9139 11.2794 21.9139 11.2792 21.9139C8.16734 21.9139 5.54913 21.7679 3.50923 21.5889C2.25181 21.4786 1.46449 20.1769 1.94656 19.0104C3.28371 15.7743 4.9346 12.5777 6.87129 9.47734C8.18956 7.36698 9.46217 5.58821 10.5383 4.18871C11.2888 3.21268 12.7571 3.2124 13.5077 4.18838C14.5785 5.5809 15.8443 7.34959 17.156 9.44696C19.0828 12.5278 20.7275 15.7044 22.0624 18.9205C22.5471 20.0881 21.7568 21.3917 20.4974 21.5024C17.3876 21.7757 14.2972 21.9139 11.2793 21.9139Z",
    fill: "#FF6363"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M12.4627 3.50842C12.0976 3.60442 11.7558 3.8334 11.503 4.19486C10.5158 5.60673 9.34846 7.40143 8.13927 9.53054C6.36261 12.6584 4.84813 15.8834 3.62174 19.1478C3.22087 20.2142 3.77643 21.3926 4.74271 21.6872C4.31066 21.6561 3.89952 21.6228 3.50929 21.5888C2.25168 21.4784 1.46469 20.1769 1.94643 19.0099C3.28363 15.7743 4.93476 12.5776 6.87144 9.4772C8.18975 7.36698 9.46218 5.58784 10.5384 4.18871C11.0135 3.57076 11.7767 3.34389 12.4627 3.50842Z",
    fill: "#D30000"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M20.7114 12.7531V12.6174C20.7114 12.1389 21.0819 11.7421 21.5593 11.7094L23.0278 11.6086C23.5538 11.5725 24.0003 11.9895 24.0003 12.5167V12.8538C24.0003 13.381 23.5537 13.798 23.0278 13.7619L21.5593 13.6611C21.082 13.6284 20.7114 13.2316 20.7114 12.7531Z",
    fill: "#FF6363"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M19.578 8.38839L19.5102 8.27087C19.271 7.85645 19.3935 7.32756 19.7905 7.06051L21.0118 6.23907C21.4493 5.94484 22.0444 6.08265 22.308 6.53921L22.4766 6.8312C22.7402 7.28776 22.562 7.8721 22.0884 8.10385L20.7664 8.75082C20.3366 8.9612 19.8173 8.80281 19.578 8.38839Z",
    fill: "#FF6363"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M16.4145 5.17496L16.297 5.10714C15.8826 4.86789 15.7243 4.3486 15.9346 3.91881L16.5816 2.59675C16.8133 2.12321 17.3977 1.945 17.8542 2.20857L18.1462 2.37714C18.6028 2.64076 18.7406 3.23589 18.4463 3.67337L17.6249 4.8947C17.3579 5.29173 16.829 5.41421 16.4145 5.17496Z",
    fill: "#FF6363"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M3.28884 12.7531V12.6174C3.28884 12.1389 2.91834 11.7421 2.44092 11.7094L0.972469 11.6086C0.446531 11.5725 0 11.9895 0 12.5167V12.8538C0 13.381 0.446531 13.798 0.972469 13.7619L2.44092 13.6611C2.9183 13.6284 3.28884 13.2316 3.28884 12.7531Z",
    fill: "#FF6363"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M4.4221 8.38839L4.48993 8.27087C4.72918 7.85645 4.60669 7.32756 4.20966 7.06051L2.98833 6.23907C2.55085 5.94484 1.95572 6.08265 1.6921 6.53921L1.52354 6.8312C1.25991 7.28776 1.43818 7.8721 1.91171 8.10385L3.23377 8.75082C3.66357 8.9612 4.18285 8.80281 4.4221 8.38839Z",
    fill: "#FF6363"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    d: "M7.58581 5.17496L7.70333 5.10714C8.11775 4.86789 8.27609 4.3486 8.06576 3.91881L7.4188 2.59675C7.18705 2.12321 6.6027 1.945 6.14614 2.20857L5.85415 2.37714C5.39759 2.64076 5.25978 3.23589 5.55401 3.67337L6.37545 4.8947C6.6425 5.29173 7.17139 5.41421 7.58581 5.17496Z",
    fill: "#FF6363"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_9",
    d: "M11.4797 8.44339C11.8298 8.40819 12.18 8.40819 12.5301 8.44339C12.9732 8.48797 13.3123 8.85796 13.3287 9.30289C13.382 10.7583 13.382 12.2137 13.3287 13.6692C13.3123 14.1141 12.9732 14.4841 12.5301 14.5287C12.18 14.5639 11.8298 14.5639 11.4797 14.5287C11.0367 14.4841 10.6975 14.1141 10.6812 13.6692C10.6278 12.2137 10.6278 10.7583 10.6812 9.30289C10.6975 8.85791 11.0367 8.48793 11.4797 8.44339Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_10",
    d: "M11.505 16.1262C11.8383 16.1103 12.1715 16.1103 12.5047 16.1262C12.964 16.1482 13.3328 16.5179 13.3535 16.9771C13.3737 17.4249 13.3737 17.8726 13.3535 18.3204C13.3328 18.7797 12.964 19.1494 12.5047 19.1714C12.1715 19.1873 11.8383 19.1873 11.505 19.1714C11.0458 19.1494 10.677 18.7797 10.6563 18.3204C10.6361 17.8727 10.6361 17.4249 10.6563 16.9771C10.677 16.5179 11.0458 16.1482 11.505 16.1262Z",
    fill: "white"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQrNotAvaiable);
export default __webpack_public_path__ + "static/media/qr-not-avaiable.c1ba14a1a4ac5bc1cd02b420f914cd4d.svg";
export { ForwardRef as ReactComponent };